<template>
  <div class="listParts_wrapper hallList_wrapper">
    <div class="title_area wrapper">
      <h4 class="inner light">
        <span>ホール一覧</span>
      </h4>
    </div>
    <div class="hallList_inner">
      <ul class="hall_list listStyle_normalFlex">
        <li v-for="hall in $store.getters['hall/all']" :key="hall.name" class="selected">
          <router-link :to="{name: 'Hall', params: {hallSlug: hall.slug}}">
            <div class="pIcon_wrapper" v-if="user.hall === hall.slug"><img :src="user.avatar" /></div>
            <h2>
              <span>{{ hall.name }}</span>
            </h2>
            <div class="audience_parts wrapper">
              <div class="inner light">
                <fa-icon icon="users" />
                <span>{{ $store.getters["participants/countByHallSlug"](hall.slug) }}</span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <!-- /hall_list -->
    </div>
    <!-- /hallList_inner -->
  </div>
  <!-- /hallList_wrapper -->
</template>

<script>
export default {
  name: "HallsList",
  computed: {
    user() {
      return this.$store.getters["auth/user"]
    }
  }
}
</script>
